import * as CONFIG from "../../../config";
import { CONSTANT_ACTIONS } from "../../../constants";

export const cnp_v1_fe_path = CONFIG.APP_CONFIG.CNP_V1_FE_API_GATEWAY;
export const headers = {
  Accept: "*/*",
  "Content-Type": "application/json; charset=utf-8",
  "Access-Control-Allow-Origin": "*",
};

// export const API_ACTION = CONSTANT_ACTIONS.ACTION_API
export const ACTION = CONSTANT_ACTIONS.COMMON_ACTION;
